module.exports = __webpack_public_path__ + "static/media/edit_808080.4ac55b3b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/edit_808080.svg
// module id = 493
// module chunks = 51